
import React from 'react';

export const NoticeSection: React.FC = () => {
  const notices = [
    {
      date: '추후 공지',
      title: '주민 설명회 개최 안내',
      description: '모아타운 사업 개요 및 참여 혜택에 대한 상세 설명',
      status: '예정',
      link: '#',
    },
    {
      date: '추후 공지',
      title: '전문가 자문 결과 공유',
      description: '전문가 자문위원회 검토 결과 및 개선 방안',
      status: '예정',
      link: '#',
    },
  ];

  // Defensive check – if the notices array is unexpectedly absent or not an array,
  // render a fallback UI to avoid runtime crashes.
  if (!Array.isArray(notices) || notices.length === 0) {
    return (
      <section id="notice" className="py-20 bg-white">
        <div className="container mx-auto px-4 text-center">
          <p className="text-gray-600">현재 표시할 공지가 없습니다.</p>
        </div>
      </section>
    );
  }

  return (
    <section id="notice" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            공지 및 타임라인
          </h2>
          <p className="text-lg text-gray-600">
            다가오는 일정과 중요 공지사항을 확인하세요
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {notices.map((notice, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-lg p-6 hover:shadow-lg transition-shadow"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center">
                    <div className="w-3 h-3 bg-green-500 rounded-full mr-3"></div>
                    <span className="text-sm font-medium text-gray-600">
                      {notice.date}
                    </span>
                  </div>
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${
                      notice.status === '예정'
                        ? 'bg-blue-100 text-blue-700'
                        : 'bg-yellow-100 text-yellow-700'
                    }`}
                  >
                    {notice.status}
                  </span>
                </div>

                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  {notice.title}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {notice.description}
                </p>

                <a
                  href={notice.link}
                  className="text-green-600 hover:text-green-700 text-sm font-medium flex items-center cursor-pointer"
                >
                  더보기
                  <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            ))}
          </div>

          {/* 중요 안내 */}
          <div className="mt-12 bg-blue-50 border border-blue-200 rounded-lg p-6">
            <div className="flex items-start">
              <div className="w-6 h-6 flex items-center justify-center mr-3 mt-1">
                <i className="ri-information-line text-blue-600"></i>
              </div>
              <div>
                <h4 className="font-semibold text-blue-900 mb-2">
                  중요 안내
                </h4>
                <p className="text-sm text-blue-800 leading-relaxed">
                  모든 일정은 사업 진행 상황에 따라 변경될 수 있으며,
                  변경 시 개별 연락 및 공지를 통해 안내드립니다.
                  정확한 일정은 주민 설명회에서 상세히 안내해드릴 예정입니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
